<template>
  <div id="cash">
    <div class="card flex-card">
      <div class="figure">
        <h1>{{ rule.total_income | price }}</h1>
        <p>当前收入（含未提现）</p>
      </div>
      <div class="figure">
        <h1>{{ rule.history_income | price }}</h1>
        <p>累计提现</p>
      </div>
    </div>
  </div>
</template>

<script>
import { price } from "./utils"
export default {
  name: "cash",
  props: ["rule"],
  filters: { price },
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
